export default __webpack_public_path__ + "static/media/artiesLeft.7bfab46d.png";